import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StarIcon, UserCircleIcon } from "@phosphor-icons/react";

export default function SellerReviews({ sellerId }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!sellerId) return;
    (async () => {
      try {
        const r = await api.get(`/sellers/${sellerId}/reviews`, {
          params: { limit: 20 },
        });
        setItems(r.data.items || []);
        setTotal(r.data.total || 0);
      } catch {}
      setLoaded(true);
    })();
  }, [sellerId]);

  if (!loaded) return null;
  if (total === 0) {
    return (
      <div
        className="rounded-2xl border border-zinc-200 p-6 text-center text-sm text-zinc-500 bg-zinc-50"
        data-testid="reviews-empty"
      >
        No reviews yet. Be the first to leave one after your next purchase.
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="reviews-list">
      {items.map((r) => (
        <div
          key={r.id}
          className="rounded-xl border border-zinc-200 p-4 bg-white"
          data-testid={`review-${r.id}`}
        >
          <div className="flex items-center gap-3">
            <div className="h-8 w-8 rounded-full bg-zinc-100 overflow-hidden grid place-items-center">
              {r.buyer_picture ? (
                <img src={r.buyer_picture} alt="" className="h-full w-full object-cover" />
              ) : (
                <UserCircleIcon size={28} className="text-zinc-400" />
              )}
            </div>
            <div className="flex-1">
              <p className="font-semibold text-sm">{r.buyer_name}</p>
              <p className="text-[11px] text-zinc-500">
                {r.created_at ? new Date(r.created_at).toLocaleDateString() : ""}
                {r.listing_title ? ` · ${r.listing_title}` : ""}
              </p>
            </div>
            <div className="flex gap-0.5">
              {[1, 2, 3, 4, 5].map((n) => (
                <StarIcon
                  key={n}
                  size={14}
                  weight={n <= r.rating ? "fill" : "regular"}
                  className={n <= r.rating ? "text-amber-500" : "text-zinc-300"}
                />
              ))}
            </div>
          </div>
          {r.comment && (
            <p className="mt-2 text-sm text-zinc-700 leading-relaxed">{r.comment}</p>
          )}
        </div>
      ))}
    </div>
  );
}
